export default __webpack_public_path__ + "static/media/service.4d7156f2.svg";